import { MutationTree } from "vuex";
import { StatisticState, DetailItem, TelegramOtpGroupItem } from "./types";

export const mutations: MutationTree<StatisticState> = {
  setTelegramOtpStatisticDetail: (state, data: DetailItem[]) => state.telegramOtpStatisticDetail = data,
  pushTelegramOtpStatisticDetail: (state, data: DetailItem[]) => state.telegramOtpStatisticDetail = state.telegramOtpStatisticDetail.concat(data),
  setTelegramOtpStatisticGroup: (state, data: TelegramOtpGroupItem[]) => state.telegramOtpStatisticGroup = data,
};
